import { setVehicleInteractionTypes } from '@customer/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { MultiselectFilter } from './MultiselectFilter';
import { FilterInputProps } from '@customer/filters/types';
import { VIType } from '@customer/store/apis/interactionsApi';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

// Remove "Unknown" from the list
const VI_TYPES: VIType[] = Object.values(VIType).slice(1);

const useVehicleInteractionTypeOptions = (): DropdownItemProps<VIType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return VI_TYPES.map((value: VIType) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`vi.name.${value}`),
      };
    });
  }, [t]);
};

export const VehicleInteractionTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<VIType>
      filterName="vehicleInteractionTypes"
      label={label ?? t('InteractionType')}
      action={setVehicleInteractionTypes}
      elementRef={elementRef}
      useItemsHook={useVehicleInteractionTypeOptions}
    />
  );
};

export default VehicleInteractionTypesFilter;
